import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import React from 'react';
import { connect } from "react-redux";
import Details from './Details.js'
import TaxRates from './TaxRates/Porezi.js'
import Users from './Users/Korisnici.js'
import { withNamespaces } from 'react-i18next';
import { isMobile } from 'react-device-detect';

export class TabContainer extends React.Component{
    render(){  
        const { t } = this.props

        let stil = {wordBreak : "normal"}
        if(isMobile){
            stil = {
                wordBreak : "normal",
                width: "fit-content"
            }
        }

        return(
            <div className="dashboardTabsAdmin">
                <Tabs>
                    <TabList >
                        <Tab style={stil}>{t('General')}</Tab>
                        <Tab style={stil}>{t('Tax rate')}</Tab>
                        <Tab style={stil}>{t('Users')}</Tab>
                    </TabList>
                    <hr className="p-0 m-0" />
                    <TabPanel>
                        <Details />
                    </TabPanel>   
                    <TabPanel>
                        <TaxRates />
                    </TabPanel>  
                    <TabPanel>
                        <Users />
                    </TabPanel>  
                </Tabs>
            </div>
        )
    };
};

const mapStateToProps = state => {
    return {      
    };
  };
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(TabContainer));
